export default __webpack_public_path__ + "img/pin_icons/pump_w.svg";